<template>
  <div class="phoneLogin">
    <common>
      <template slot="content">
        <div class="password_login">
          <el-form ref="phoneLogin" :model="form" :rules="rules" >
            <el-form-item prop="phone" label="手机号:">
              <el-input placeholder="" clearable type="tel" v-model="form.phone" @change='phoneChange'
                        class="input-box">
              </el-input>
            </el-form-item>
            <el-form-item prop="code" label="验证码:">
              <el-input placeholder="" clearable type="tel" v-model="form.code" maxlength="6" class="input-boxs">
              </el-input>
              <div class="cout-timer" :class="{disabled: isSendMsg}" v-text="sendMsg"
                   @click="sendCode('phoneLogin')"></div>
            </el-form-item>
            <!--<p class="warning">{{smsDisplay}}</p>-->
            <div class="button-group" @click="submitForm('phoneLogin')"></div>
          </el-form>
        </div>
      </template>
    </common>
  </div>
</template>

<script>

  import {Toast} from 'mint-ui'
  import common from './common'

  export default {
    name: 'loginPhone',
    components: {common},
    data () {
      return {
        form: {
          phone: '',
          code: ''
        },
        rules: {
          phone: [{
            required: true,
            message: '请输入手机号',
            trigger: 'blur'
          },
            {
              pattern: /^0?(13[0-9]|14[5,7]|15[0-3,5-9]|17[0,3,5-8]|18[0-9]|166|198|199)[0-9]{8}$/,
              message: '请输入正确的手机号',
            }
          ],
          code: [{
            required: true,
            message: '请输入验证码',
            trigger: 'blur'
          },
            {
              pattern: /(^0$)|(^[0-9]*$)/,
              message: '请输入数字',
            },
            {
              pattern: /^(\w){6}$/,
              message: '请输入6位短信验证码',
            }
          ],
        },
        sendMsg: '获取验证码',
        isSendMsg: false,
      }
    },
    methods: {
      phoneChange () {
      },
      //
      sendCode (formName) {
        this.$refs[formName].validateField('phone', (valid) => {
          if (valid == '') {
            if (this.isSendMsg) return false
            this.isSendMsg = true
            this.sendCodeMsg()
          } else {
            return false
          }
        })
      },
      //验证码倒计时
      countDown () {
        if (this.isSendMsg) {
          let cont = 60
          var startTime = Date.parse(new Date())
          this.sendMsg = `${cont}秒`
          this.countDownTimer = setInterval(() => {
            --cont
            var nowTime = Date.parse(new Date())
            var realcount = parseInt((nowTime - startTime) / 1000) - (60 - cont)
            if (realcount > 6) {
              cont = (cont - realcount) > 0 ? (cont - realcount) : 0
            }
            if (cont == 0) {
              this.clearCountDownTimer()
              return false
            }
            this.sendMsg = `${cont}秒`
          }, 1000)
        }
      },
      //倒计时结束
      clearCountDownTimer () {
        clearInterval(this.countDownTimer)
        this.countDownTimer = null
        this.sendMsg = `重新获取`
        this.isSendMsg = false
      },
      //发送验证码请求
      sendCodeMsg () {
        const that = this
        this.newAjax({
          url: '/goldenpheasant/service/sms/getVerifyCode',
          data: {
            'mobile': that.form.phone
          },
          success: function (data) {
            that.countDown()
          },
          error: function (error) {
            Toast({
              message: '登录失败，请重新登录！',
              position: 'centent',
              duration: 5000
            })
          }
        })
      },
      //点击验证码登录
      submitForm (formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.handleLogin()
          } else {
            this.smsDisplay = ''
          }
        })
      },
      //验证码登录
      handleLogin () {
        const that = this
        this.newAjax({
          url: '/goldenpheasant/service/sms/validateVerifyCode',
          data: {
            'mobile': that.form.phone,
            'verifyCode': that.form.code
          },
          success:function(data){
            if(data.errorCode==0){
              sessionStorage.setItem("mobile",that.form.phone);
              that.$router.replace("/index");
            }else{
              Toast({
                message: data.response,
                position: 'centent',
                duration: 5000
              })
            }
          },
          error: function (error) {
            Toast({
              message: "登录失败，请刷新后重试！",
              position: 'centent',
              duration: 5000
            })
          }
        })
      },
    }
  }
</script>

<style scoped lang="less">
  /deep/ .el-form-item__label {
    font-size: 0.864rem;
    color: #FFE6B9;
    padding: 0 0.768rem 0 0;
  }

  /deep/ .el-input__inner {
    background-color: transparent;
    border: 0.048rem solid #FFE6B9;
    font-size: 0.864rem;
    color: #FFE6B9;
    border-radius: 0;
  }
  .password_login {
    margin-top: 4.224rem;
    margin-left: 1.2rem;
    margin-right: 2.016rem;
  }

  .input-box {
    width: 10.56rem;
    color: #FFE6B9;
    font-size: 0.864rem;
    float: left;
  }

  .input-boxs {
    width: 5.28rem;
    color: #FFE6B9;
    font-size: 0.864rem;
    float: left;
  }

  .cout-timer {
    display: inline-block;
    background: url("../assets/images/bg-tbn.png") no-repeat;
    width: 4.512rem;
    height: 40px;
    background-size: cover;
    font-size: 16/375*18rem;
    color: #80531F;
  }

  .button-group {
    background: url("../assets/images/login.png") no-repeat;
    background-size: contain;
    margin: 2.448rem auto 0;
    width: 11.52rem;
    height: 1.824rem;
  }

  /* 如果设备像素大于等于2，则用2倍图 */
  @media screen and (-webkit-min-device-pixel-ratio: 2), screen and (min--moz-device-pixel-ratio: 2) {
    .button-group {
      background: url("../assets/images/login@2x.png") no-repeat;
      background-size: contain;
    }
  }
  @media screen and (-webkit-min-device-pixel-ratio: 3), screen and (min--moz-device-pixel-ratio: 3) {
    .button-group {
      background: url("../assets/images/login@3x.png") no-repeat;
      background-size: contain;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/loginPhone.vue